import Vue from 'vue'
import store from '../store'
import axios from 'axios'
import { router } from '../router/index'

const ajaxUrl = process.env.NODE_ENV === 'development' ?
   'http://localhost:8081/api':
   'http://www.4008115225.com:80';
let ajax = axios.create({
  baseURL: ajaxUrl,
  timeout: 30000
});

ajax.defaults.headers.common = {
  'X-Requested-With': 'XMLHttpRequest',
  Pragma: 'no-cache',
  'Cache-Control': 'no-cache'
};

//请求预处理
ajax.interceptors.request.use(config => {
  let token = Vue.ls.get('token') || ''
  config.params ? config.params.token = token : config.params = { token: token }
  return config
}, error => {
  return Promise.reject(error)
});

//统一报错提示
ajax.interceptors.response.use(response => {
  store.commit('setBtnLoading', false)
  //删除失败报错
  if(response.status == '204') {
    Vue.prototype.$Message.error(JSON.parse(response.statusText).errMsg)
    return Promise.reject(response)
  }

  if(response.status != '204' && response.data.errCode < 0) {
    Vue.prototype.$Message.error(response.data.errMsg)

    //token 已过期
    if (response.data.errCode == -4 || response.data.errCode == -1007) {
      router.replace({
        name:'login'
      })
    }
    return Promise.reject(response)
  } else {
    return response
  }
}, error => {
  store.commit('setBtnLoading', false)
  return Promise.reject(error)
});

//封装请求方法
const request = {
  post(url, data) {
    return ajax({
      method: 'post',
      url,
      data
    })
  },
  get(url, params) {
    return ajax({
      method: 'get',
      url,
      params
    })
  },
  delete(url, params) {
    return ajax({
      method: 'delete',
      url,
      params
    })
  }
}


//api接口封装
const api = {
  //登录
  login(data) {
    return request.post('/users/web/login', data)
  },
  //新增用户
  addUser(data) {
    return request.post('/users/web/register', data)
  },
  //删除用户
  delUser(id) {
    return request.delete('/users/web/deleteuserinfos', {id})
  },
  //修改用户
  editUser(data) {
    return request.post('/users/web/updateuserinfos', data)
  },
  //用户列表
  getUser(params) {
    return request.get('/users/web/getuserinfos', params)
  },
  //新增部门
  addDepartment(data) {
    return request.post('/users/web/adddepartmentinfos', data)
  },
  //删除部门
  delDepartment(id) {
    return request.delete('/users/web/deletedepartmentinfos', {id})
  },
  //修改部门
  editDepartment(data) {
    return request.post('/users/web/updatedepartmentinfos', data)
  },
  //部门列表
  getDepartment(params) {
    return request.get('/users/web/getdepartmentinfos', params)
  },
  //获取所有的可用权限列表
  getAuthList() {
    return request.get('/users/web/getauthoritylist')
  },
  //获取用户的分配的所有权限信息
  getAuth(params) {
    return request.get('/users/web/getuserauthoritylist', params)
  },
  //修改用户权限
  editAuth(data) {
    return request.post('/users/web/updateuserauthority', data)
  },
  //新增学校
  addSchool(data) {
    return request.post('/users/web/addcampus', data)
  },
  //删除学校
  delSchool(id) {
    return request.delete('/users/web/deletecampusinfos', {id})
  },
  //修改学校
  editSchool(data) {
    return request.post('/users/web/updatecampus', data)
  },
  //学校列表
  getSchool(params) {
    return request.get('/users/web/getcampusinfos', params)
  },
  //大阶段列表
  getPhase() {
    return request.get('/lesson/web/getsubjectinfos')
  },
  //新增章节
  addChapter(data) {
    return request.post('/lesson/web/addlessoninfos', data)
  },
  //删除章节
  delChapter(id) {
    return request.delete('/lesson/web/deletelessoninfos', {id})
  },
  //修改章节
  editChapter(data) {
    return request.post('/lesson/web/updatelessoninfos', data)
  },
  //章节列表
  getChapter(params) {
    return request.get('/lesson/web/getlessoninfos', params)
  },
  //新增课程
  addCourse(data) {
    return request.post('/lesson/web/addchapterinfos', data)
  },
  //删除课程
  delCourse(id) {
    return request.delete('/lesson/web/deletechpaterinfos', {id})
  },
  //修改课程
  editCourse(data) {
    return request.post('/lesson/web/updatechapterinfos', data)
  },
  //课程列表
  getCourse(params) {
    return request.get('/lesson/web/getchapterinfos', params)
  },
  //新增关卡
  addBarrier(data) {
    return request.post('/lesson/web/addlevelinfos', data)
  },
  //删除关卡
  delBarrier(id) {
    return request.delete('/lesson/web/deletelevelinfos', {id})
  },
  //修改关卡
  editBarrier(data) {
    return request.post('/lesson/web/updatelevelinfos', data)
  },
  //关卡列表
  getBarrier(params) {
    return request.get('/lesson/web/getlevelinfos', params)
  },
  //获取题目类型
  getQuestionType() {
    return request.get('/lesson/web/getproblemtypeinfos')
  },
  //新增题目
  addQuestion(data) {
    return request.post('/lesson/web/addquestion', data)
  },
  //删除题目
  delQuestion(id) {
    return request.delete('/lesson/web/deletequestion', {id})
  },
  //修改题目
  editQuestion(data) {
    return request.post('/lesson/web/updatequestion', data)
  },
  //题目列表
  getQuestion(params) {
    return request.get('/lesson/web/getquestioninfos', params)
  },
  //新增每日任务
  addDaily(data) {
    return request.post('/lesson/web/addeverydaytask', data)
  },
  //删除每日任务
  delDaily(id) {
    return request.delete('/lesson/web/deleteeverydaytask', {id})
  },
  //修改每日任务
  editDaily(data) {
    return request.post('/lesson/web/updateeverydaytask', data)
  },
  //每日任务列表
  getDaily(params) {
    return request.get('/lesson/web/gettaskinfos', params)
  },
  //获取用户的积分
  getScore(params) {
    return request.get('/points/web/getuserpoints', params)
  },
  //扣减用户积分
  editScore(data) {
    return request.post('/points/web/reduceuserpoints', data)
  },
  //获取系统操作日志
  getLog(params) {
    return request.get('/logs/web/getsyslogs', params)
  },
  //获取营收流水列表
  getRevenue(params) {
    return request.get('/pay/web/getpayinfolist', params)
  },
  //获取支付类型
  getfeecatalogs(params) {
    return request.get('/pay/web/getfeecatalogs', params)
  },
  //更新支付类型信息
  updatefeedetails(params) {
    return request.post('/pay/web/updatefeedetails', params)
  },
  //获取曲库分类
  getscorelibcatalogs(params) {
    return request.get('/scorelib/web/getscorelibcatalogs',params)
  },
  //新增分类
  addscorelibcatalogs(data) {
    return request.post('/scorelib/web/addscorelibcatalogs', data)
  },
  //编辑分类
  updatescorelibcatalogs(data) {
    return request.post('/scorelib/web/updatescorelibcatalogs', data)
  },
  //删除分类
  deletescorelibcatalogs(id) {
    return request.delete('/scorelib/web/deletescorelibcatalogs', {id})
  },
  //曲目列表
  getsonglibscores(params) {
    return request.get('/scorelib/web/getsonglibscores',params)
  },
  //新增曲目
  addsonglibscore(data) {
    return request.post('/scorelib/web/addsonglibscore', data)
  },
  //编辑曲目
  updatesonglibscore(data) {
    return request.post('/scorelib/web/updatesonglibscore', data)
  },
  //删除曲目
  deletesonglibscore(id) {
    return request.delete('/scorelib/web/deletesonglibscore', {id})
  },
  //考级课程列表
  getgradelessoninfos(params) {
    return request.get('/lesson/web/getgradelessoninfos',params)
  },
  //新增考级课程
  addgradelessoninfos(data) {
    return request.post('/lesson/web/addgradelessoninfos', data)
  },
  //编辑考级课程
  updategradelessoninfos(data) {
    return request.post('/lesson/web/updategradelessoninfos', data)
  },
  //删除考级课程
  deletegradelessoninfos(id) {
    return request.delete('/lesson/web/deletegradelessoninfos', {id})
  }
}


export default api


// WEBPACK FOOTER //
// ./src/api/api.js